/* eslint-disable import/no-unresolved */
import { useDispatch, useSelector } from 'react-redux';
import {
  Modal,
  Box,
  Button,
  Typography,
  Slide,
  Backdrop,
  Stack,
  IconButton,
} from '@mui/material';
import Icon from '@/components/Icon';
import { selectModal } from '@/store/selectors';
import { closeModal, ModalType, openModal } from '@/store/slices/modal';
import { updateCurrentName } from '@/store/slices/printer';

const boxStyle = {
  position: 'absolute',
  height: '555px',
  width: '500px',
  backgroundColor: '#fff',
  borderRadius: '10px',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  margin: 'auto',
  textAlign: 'center',
  p: 4,
};

interface PrinterButtonProps {
  name: string;
  handleClick: (modalType: ModalType, printerName: string) => void;
  modalType: ModalType;
}

const PrinterButton: React.FC<PrinterButtonProps> = ({
  name,
  handleClick,
  modalType,
}) => (
  <Button
    variant="contained"
    disableElevation
    onClick={() => handleClick(modalType, name)}
    sx={{
      backgroundColor: '#F9F9F9',
      border: '1px solid #E0E0E0',
      color: '#000',
      borderRadius: '14px',
      fontWeight: 400,
      '&:hover': {
        backgroundColor: '#E0E0E0',
      },
    }}
  >
    {name}
  </Button>
);
const ChoosePrinter = () => {
  const { choosePrinter } = useSelector(selectModal);
  const dispatch = useDispatch();

  const handleModalClose = () => {
    dispatch(closeModal({ type: 'choosePrinter' }));
  };

  const handleAction = (modalType: ModalType, printerName: string) => {
    dispatch(closeModal({ type: 'choosePrinter' }));

    dispatch(updateCurrentName(printerName));

    dispatch(openModal({ type: modalType }));
  };
  return (
    <div>
      <Modal
        open={choosePrinter}
        onClose={handleModalClose}
        aria-labelledby="logout-modal-title"
        aria-describedby="logout-modal-description"
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Slide direction="up" in={choosePrinter} mountOnEnter unmountOnExit>
          <Box sx={boxStyle}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
              }}
            >
              <Typography
                variant="h5"
                sx={{
                  lineHeight: '40px',
                  fontWeight: 700,
                  fontFamily: 'Fellix',
                  fontSize: '32px',
                  color: '#0A083A',
                }}
              >
                Add Printer
              </Typography>
              <Box>
                <IconButton
                  onClick={handleModalClose}
                  sx={{
                    width: '45px',
                    height: '45px',
                    p: '12px 16px',
                    '& svg path': {
                      fill: '#0043B9',
                    },
                  }}
                >
                  <Icon icon="cancel" width={45} height={45} />
                </IconButton>
              </Box>
            </Box>

            <Stack mt={15} width="324px" mx="auto" spacing={3}>
              <PrinterButton
                name="Default Printer"
                handleClick={handleAction}
                modalType="defaultPrinter"
              />
              <PrinterButton
                name="Receipt Printer"
                handleClick={handleAction}
                modalType="defaultPrinter"
              />
              <PrinterButton
                name="KOT Printer"
                handleClick={handleAction}
                modalType="KOTPrinter"
              />
            </Stack>
          </Box>
        </Slide>
      </Modal>
    </div>
  );
};

export default ChoosePrinter;
